import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=ab704ac4&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab704ac4')) {
      api.createRecord('ab704ac4', component.options)
    } else {
      api.reload('ab704ac4', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=ab704ac4&", function () {
      api.rerender('ab704ac4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24N98mfpOBa4T/JS/imageCarousel.vue"
export default component.exports